import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../service";
import {ICodeName as dictionaryInterface} from "../../models";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "./view-dictionary-base";

@Component({
  selector: 'app-dict-qref-prizndoc4936',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefPrizndoc4936ViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         fieldsFromSearch="name"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          {{ item.name }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          <div style="white-space: normal">
            {{ item.name }}
          </div>
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefPrizndoc4936ViewComponent extends ViewDictionaryBase<dictionaryInterface> {
  getDictionary = this.dictSrv.getQrefPrizndoc4936List();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
